import Swal from "sweetalert2";

function sweetDesicion(title, text, icon) {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    showCancelButton: true,
    confirmButtonColor: "#0046ad",
    cancelButtonColor: "#ED1C24",
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
  });
}

function sweetAlert(title, text, icon) {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonColor: "#0046ad",
  });
}

function timerAlert(title, text, timer) {
  let timerInterval;
  return Swal.fire({
    title: title,
    html: text,
    timer: timer,
    showConfirmButton: true,
    focusConfirm: false,
    confirmButtonText: "Salir",
    confirmButtonColor: "#ff3855",
    allowEscapeKey: false,
    timerProgressBar: true,
    allowOutsideClick: false,
    customClass: {
      container: "sweet-timer-container",
      popup: "sweet-timer-popup",
      title: "sweet-timer-title",
      htmlContainer: "sweet-timer-content",
      actions: "sweet-timer-actions",
      confirmButton: "sweet-timer-confirm-btn",
    },
    willClose: () => {
      clearInterval(timerInterval);
    },
  });
}

export const sweetService = { sweetDesicion, sweetAlert, timerAlert };
